import type { Ref } from 'vue'

import { storeToRefs } from 'pinia'

import { useMyCoursesSearchStore } from '../stores/my-courses-search.ui-store'

export interface UseMyCoursesSearch {
  /** Current search query shared between the shell top bar and the courses grid. */
  searchQuery: Ref<string>
  /** Update the shared search query. */
  setSearchQuery: (value: string) => void
  /** Clear the shared search query. */
  reset: () => void
}

/**
 * Component-facing API for the shared My Courses search state.
 *
 * Wraps the Pinia UI store so components depend on the composable boundary
 * (Component → Composable → Store) instead of importing the store directly.
 */
export function useMyCoursesSearch(): UseMyCoursesSearch {
  const store = useMyCoursesSearchStore()
  const { searchQuery } = storeToRefs(store)

  return {
    searchQuery,
    setSearchQuery: store.setSearchQuery,
    reset: store.reset,
  }
}
